module.exports = __webpack_public_path__ + "img/satoshi.i.18f0e233.png";